module.exports = __webpack_public_path__ + "img/avatar6.ec22148f.png";